import DevicesInfoChip from './DevicesInfoChip';

export default DevicesInfoChip;
